module.exports = __webpack_public_path__ + "img/infront.7db3a110.png";